import React from 'react';
import { Link } from 'react-router-dom';

import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import { Redirect } from 'react-router-dom';
import { useOfflineAssets } from '../offline/useOfflineAssets';
import { Grid, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    container: {
        margin: '5% auto'
    },
    refresh: {
        textDecoration: 'underline',
        color: 'blue',
        cursor: 'pointer'
    }
}));

interface Props {
    errorMessage?: string;

}

export function ServerFailed(props:Props) {
    const { errorMessage,  } = props;
    const { onlineMode } = useOfflineAssets();
    const classes = useStyles();

    return (
        <>
            <Grid container>
                <Grid item xs={12} sm={6} className={classes.container}>
                    <Typography variant='h6' color="textSecondary" align='center'>
                        <SentimentVeryDissatisfiedIcon style={{ marginTop: "50px", width: "170px", height: "170px", color: "#CCC" }} /><br/>
                        {errorMessage ? 
                        <>
                            {errorMessage} Please try <span className={classes.refresh} onClick={() => onlineMode ? window.location.reload() : <Redirect to='library-offline' />}>refreshing</span> the page. If the problem continues, contact our customer support team by <a href="mailto:support@sermoncentral.com">email</a> or call <a href="tel:866-899-4426">866-899-4426</a>.</> 
                        : 
                        <Typography>We're sorry, but we're having trouble processing your request. Please click <span className={classes.refresh} onClick={() => onlineMode ? window.location.reload() : <Link to="/" />}>here</span> to try again. If you continue to experience difficulties contact our customer service team by <a href="mailto:support@sermoncentral.com">email</a> or call <a href="tel:866-899-4426">866-899-4426</a>.</Typography>
                        }
                    </Typography>
                </Grid>
            </Grid>
        </>
    );
}